export const UPDATE_FORM_HIGHLIGHTS = 'UPDATE_FORM_HIGHLIGHTS'
